export const BREAKPOINT_DELTA = 32;
export const PREVIEW_HORIZONTAL_MARGIN = 42;
export const TABLET_MIN_WIDTH = 834;
export const TABLET_WIDTH = 1024;
export const TABLET_LAPTOP_WIDTH = 1200;
export const DESKTOP_WIDTH = 1440;
export const WIDE_DESKTOP_WIDTH = 1920;
export const COMMONLY_SMALL_TABLET = 768;
export const COMMONLY_LARGE_LAPTOP = 1728;
export const MOBILE_MIN_RANGE = 0;
export const MOBILE_MAX_RANGE = 1023;
export const MOBILE_CANVAS_SIZE = 390;
export const DESKTOP_CANVAS_SIZE = 1280;
export const LARGE_SCREEN_SIZE = 2100;
